module.exports = __webpack_public_path__ + "img/arw-link-primary.0fa23e7e.svg";